import React from "react";

export function CloseIcon({ width, height, ...props }) {
  const viewBoxSize = 40;
  const newWidth = width || viewBoxSize;
  const newHeight = height || viewBoxSize;

  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
          width={newWidth}
          height={newHeight}
          stroke="white"
          {...props}
      >
        <line x1="10" y1="10" x2="30" y2="30" strokeWidth="1.5" />
        <line x1="10" y1="30" x2="30" y2="10" strokeWidth="1.5" />
      </svg>
  );
}
